module.exports = __webpack_public_path__ + "img/logoseebsintrafgv.e2eb3eef.svg";